/** Containing a list of occupations for proposers. Each object has an id and a value representing the occupation. */
export const occupationListForProposer = [
  { id: 6, value: "A/C DUCTMAN" },
  { id: 7, value: "Advocate / Lawyer" },
  { id: 8, value: "Businessman/Industrialist Large Scale" },
  { id: 9, value: "Businessman/Industrialist Medium Scale" },
  { id: 10, value: "Businessman/Industrialist Small Scale" },
  { id: 11, value: "Carpenter" },
  { id: 12, value: "Chartered Accountants" },
  { id: 13, value: "Clerical" },
  { id: 14, value: "Cook" },
  { id: 15, value: "ELECTRIC ARC WELDER" },
  { id: 16, value: "Executive - Middle Level" },
  { id: 17, value: "Executive - Senior Level" },
  { id: 18, value: "Executive Junior Level" },
  { id: 19, value: "Farming" },
  { id: 20, value: "Housemaid" },
  { id: 21, value: "HouseWife" },
  { id: 22, value: "INDUSTRIAL WIRING ELECTRICIAN" },
  { id: 23, value: "Labourer" },
  { id: 24, value: "Mason" },
  { id: 25, value: "Not Working" },
  { id: 26, value: "Others" },
  { id: 27, value: "OXYGEN WELDER" },
  { id: 28, value: "Reinforcing Fitter" },
  { id: 29, value: "Retired" },
  { id: 30, value: "Salesperson" },
  { id: 31, value: "Self employed Professional" },
  { id: 32, value: "Service" },
  { id: 33, value: "Shop owner" },
  { id: 34, value: "Software Professional" },
  { id: 35, value: "Steel Fixer" },
  { id: 36, value: "Student" },
  { id: 37, value: "Supervisor" },
];

/** Containing a list of occupations for insureds. Each object has an id and a value representing the occupation. */
export const occupationListForInsureds = [
  { id: 1, value: "Accountants" },
  { id: 4, value: "Contractors" },
  { id: 6, value: "Engineers engaged in superintending functions only" },
  { id: 8, value: "Veterinary Doctors" },
  { id: 10, value: "paid drivers of motorcars and light motor vehicles" },
  {
    id: 12,
    value:
      "persons engaged in occupations of similar hazard and not engaged in manual labour",
  },
  { id: 13, value: "Cash Carrying Employees" },
  { id: 15, value: "Garage and Motor Mechanics" },
  { id: 17, value: "Machine Operators" },
  { id: 19, value: "Drivers of trucks or lorries and other heavy vehicles" },
  { id: 21, value: "Professional Athletics and Sportsmen" },
  { id: 23, value: "Doctors" },
  {
    id: 25,
    value:
      "Woodworking Machinists and persons engaged in occupations of similar hazard",
  },
  { id: 26, value: "Others" },
  {
    id: 27,
    value: "Persons Working in underground mines, explosives, magazines",
  },
  {
    id: 28,
    value:
      "workers involved in electrical installation with high tension supply",
  },
  { id: 29, value: "Jockeys" },
  { id: 30, value: "Circus personnel" },
  {
    id: 31,
    value: "Persons engaged in activities like racing on wheels or horseback",
  },
  { id: 32, value: "big game hunting" },
  { id: 33, value: "mountaineering" },
  { id: 34, value: "winter sports" },
  { id: 35, value: "skiing" },
  { id: 36, value: "Lawyers" },
  { id: 38, value: "ice hockey" },
  { id: 39, value: "ballooning" },
  { id: 40, value: "hand gliding" },
  { id: 41, value: "river rafting" },
  {
    id: 42,
    value:
      "polo and persons engaged in occupations/activities of similar hazard",
  },
  { id: 43, value: "Others Risk Group 1" },
  { id: 44, value: "Others Risk Group 2" },
  { id: 45, value: "Others Risk Group 3" },
  { id: 46, value: "Housewife" },
  { id: 49, value: "Architects" },
  { id: 51, value: "Salaried" },
  { id: 52, value: "Self-Employed" },
  { id: 53, value: "Professional" },
  { id: 55, value: "Student" },
  { id: 60, value: "Consulting Engineers" },
  { id: 62, value: "Teachers" },
  { id: 64, value: "Bankers" },
  { id: 66, value: "Persons engaged in administrative functions" },
  { id: 67, value: "Builders" },
  { id: 69, value: "Business" },
  { id: 70, value: "Administrative / clerical work" },
  { id: 71, value: "Business Owner" },
  { id: 72, value: "Carpenter / welder" },
  { id: 73, value: "Consulting Engineers" },
  { id: 74, value: "Cook" },
  { id: 75, value: "Engineers engaged in workshop / floor" },
  { id: 76, value: "Agriculture / Poultry" },
  { id: 77, value: "Electrician" },
  { id: 78, value: "Driver" },
  { id: 79, value: "Retired" },
  { id: 80, value: "Salaried / service" },
  { id: 81, value: "Self-Employeed" },
  { id: 82, value: "Teacher" },
  { id: 83, value: "Mechanic" },
];

export const getSumInsuredList = () => {
  const minSumInsured = 500000;
  const maxSumInsured = 2000000;
  const stepSize = 100000;

  const sumInsuredList = [];

  for (let i = minSumInsured; i <= maxSumInsured; i += stepSize) {
    const formattedValue = i.toLocaleString("en-IN");
    const entry = { id: i, value: formattedValue };
    sumInsuredList.push(entry);
  }

  return sumInsuredList;
};

export const relationshipWithProposerList = [
  // { id: 345, value: "Self" },
  { id: 320, value: "Spouse" },
  { id: 1989, value: "Dependent Daughter" },
  { id: 1988, value: "Dependent Son" },
];

export const salutationListForInsureds = [
  { id: "Mr.", value: "Mr." },
  { id: "Mrs.", value: "Mrs." },
  { id: "Ms.", value: "Ms." },
  { id: "Dr.", value: "Dr." },
  { id: "Miss.", value: "Miss." },
];
